<template>
  <div
    class="form-group"
    :class="[{ 'has-error':error }]"
  >
    <slot />
    <p
      v-if="error"
      class="help-block validation-text"
    >
      {{ error }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'FormGroup',

  props: {
    'name': {
      required: false,
    },
    'errors': {
      required: false,
    },
  },

  computed: {
    error () {
      // if in the error object a property exists with the name of the field, return the error
      if (this.errors != null && typeof this.errors !== 'undefined' && this.errors.hasOwnProperty(this.name)) {
        return this.errors[this.name].join(' ')
      } else {
        return null
      }
    },
  },
}

</script>

<style scoped>

</style>
